var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormalPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5918_1896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08336 13.7876C0.762531 13.7876 0.500031 13.5251 0.500031 13.2043V3.68343C0.500031 3.3626 0.762531 3.1001 1.08336 3.1001C1.4042 3.1001 1.6667 3.3626 1.6667 3.68343V13.2043C1.63753 13.5251 1.4042 13.7876 1.08336 13.7876Z",
    fill: "#319BFF",
    stroke: "#319BFF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61872 0.200195C2.53538 0.200195 1.61619 0.569097 0.729829 1.37397C0.598515 1.50812 0.500031 1.6758 0.500031 1.87702V9.48983C0.500031 9.75812 0.664172 9.99288 0.89397 10.0935C1.12377 10.1941 1.38639 10.1606 1.58336 9.99288C2.23993 9.42276 2.86367 9.15446 3.61872 9.15446C4.60357 9.15446 5.65407 9.62398 6.7374 10.127C7.91922 10.6636 9.10104 11.2002 10.3813 11.2002C11.4647 11.2002 12.3839 10.8313 13.2702 10.0264C13.4015 9.89227 13.5 9.72459 13.5 9.52337V1.91056C13.5 1.64227 13.3359 1.40751 13.1061 1.3069C12.8763 1.20629 12.6137 1.23983 12.4167 1.40751C11.7601 1.97763 11.1364 2.24593 10.3813 2.24593C9.39649 2.24593 8.34599 1.77641 7.26266 1.27337C6.08084 0.770317 4.86619 0.233732 3.61872 0.200195Z",
    fill: "#319BFF",
    stroke: "#319BFF",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5918_1896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalPriority);
export default __webpack_public_path__ + "static/media/normal_priority.7e2a6447a08e2767d950f433251e5eca.svg";
export { ForwardRef as ReactComponent };